module.exports = __webpack_public_path__ + "img/bg-2_5072976.webp";